import Body from "./Body";
import Filter from "./Filter";
import Search from "./Search";
import Invoice from "./Factors";
import UserInfo from "./userInfo";
import PayDebt from "./PayDebt";

export const Components = {
  Body,
  Filter,
  Search,
  Invoice,
  UserInfo,
  PayDebt,
};
